import energy_category from './energy_category.js';

export default {
	title: 'application_settings',
	components: [
		{ title: 'ai_model', component: 'ai_model' },
		{
			title: 'device_card_customization',
			component: 'customize_device_content',
		},
		energy_category,
		{ title: 'consumption_calculation', component: 'consumption_calculation' },
		{
			title: 'consumption_hierarchy',
			component: 'consumption_hierarchy',
			test_user: true,
		},
		{ title: 'pin_lock', component: 'pin_lock' },
		{ title: 'input_state', component: 'input_state' },
		{ title: 'exclude_event_log', component: 'exclude_event_log' },
		{
			title: 'exclude_forgotten_lights',
			component: 'exclude_forgotten_lights',
			premium: true,
		},
	],
};
